import { IApp } from "../IApp";

export abstract class AppControllerBase {

    protected _app: IApp;
    constructor(app: IApp) {
        this._app = app;
    }
    protected async lockguiAsync<T>(action: Promise<T>) { return this._app.gui.lockActionAsync<T>(action); }         
}
